import { BaseSchema, BlazeTableSchema } from '@blaze-shared/schema-domain';
import { ApiCallWorkflowNode, Connection, Workflow } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WORKFLOW_SCHEMA_KEY,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ApiCall')
export class ApiCallNodeSchemaProvider extends SchemaProvider<ApiCallWorkflowNode> {
  override getSchemas(
    workflow: Workflow,
    node: ApiCallWorkflowNode,
    schemas: {
      input: Map<string | symbol, BaseSchema>;
      output: Map<string | symbol, BaseSchema>;
      allSchemas: Record<string, BaseSchema>;
      userSchema?: BlazeTableSchema | null;
      accountSchema?: BlazeTableSchema | null;
    },
    connections: Connection[],
  ): Map<string | symbol, BaseSchema> {
    const nodeSchemas = super.getSchemas(workflow, node, schemas, connections);

    const outputSchema = schemas.output.get(node.id);

    // this is meant to set the api call node schema (which should be equal to the output schema)
    // as the main workflow schema, so the $$input1 from assignments
    // can be validated correctly
    if (node.connectorId && outputSchema) {
      nodeSchemas.set(WORKFLOW_SCHEMA_KEY, outputSchema);
    }

    return nodeSchemas;
  }
}
